import styles from './Details.module.css';
import { Flex, Icon, Text, Pill } from '@/_components';
import type { DetailsProps } from './Details.types';
import type { FC } from 'react';
import { getClasses } from '@/_utils/classnames';

export const Details: FC<DetailsProps> = ({
  children,
  isAlwaysClosed,
  isCompleteAble,
  isCompleted,
  isOpen,
  isShort,
  pills,
  title,
}) => {
  const detailsClasses: string = getClasses(styles.details, {
    [styles.detailsShort]: isShort,
    [styles.isAlwaysClosed]: isAlwaysClosed,
  });

  const completedIconClasses: string = getClasses({
    [styles.details__completedIcon]: isCompleted,
    [styles.details__completedIconIncomplete]: !isCompleted,
  });

  const childredOfDetails = () => {
    return (
      <>
        <summary className="flex space-between flex-y-center">
          <Flex isYCentered={true} gap={4}>
            {isCompleteAble && (
              <Icon
                name={isCompleted ? 'check-circle-filled' : 'circle'}
                className={completedIconClasses}
                size={24}
              />
            )}
            <Text type="small" fontWeight="medium">
              {title}
            </Text>
          </Flex>
          <Flex isYCentered={true} gap={2}>
            {pills?.map((pill, key) => {
              return (
                <Pill
                  key={key}
                  {...pill}
                  isDark={true}
                  isRound={true}
                  size="normal"
                />
              );
            })}
            {!isAlwaysClosed && (
              <Icon
                name="caret-up"
                size={16}
                className={styles.details__caretIcon}
              />
            )}
          </Flex>
        </summary>
        {children}
      </>
    );
  };

  if (isAlwaysClosed) {
    return <div className={detailsClasses}>{childredOfDetails()}</div>;
  }

  return (
    <details className={detailsClasses} open={isOpen}>
      {childredOfDetails()}
    </details>
  );
};
